import { ButtonRow, ContentWrapper } from './styled';
import EyeSolid from '@simplywallst/ui-core/icons/EyeSolid';
import { Button } from '@simplywallst/ui-core';
import { useSummaryV2 } from '@/hooks/useCompany';
import { useCompanyLimits } from '@/hooks/useCompanyLimits';
import useUser from '@/hooks/useUser';
import { useUserAccess } from '@/hooks/useUserAccess';
import { useTheme } from 'styled-components';
import type { ReactNode } from 'react';
import Observer from '@researchgate/react-intersection-observer';

interface Props {
  onClick?: () => void;
  onIntersect?: () => void;
  position?: 'top' | 'bottom';
  children?: ReactNode;
}
function ShowFullReportConfirm({
  onClick,
  onIntersect,
  position = 'top',
  children = 'View Full Report',
}: Props) {
  const theme = useTheme();
  const { data: user } = useUser();
  const { data: userAccess, status: userAccessStatus } = useUserAccess();
  const summary = useSummaryV2();
  const companyId =
    summary.status === 'success' ? summary.companyId : undefined;
  const limits = useCompanyLimits(companyId);
  const isUnlimitedUser = userAccess.planType === 'unlimited';
  const canViewLimitDescription =
    !limits.visited &&
    user.loggedIn &&
    limits.status === 'success' &&
    userAccessStatus === 'success' &&
    !isUnlimitedUser;

  return (
    <ButtonRow
      justifyContent="center"
      bottomMargin={position === 'bottom' ? theme.x8spacePx : undefined}
    >
      <Observer
        threshold={0}
        onChange={(e) => {
          if (e.isIntersecting) {
            onIntersect?.();
          }
        }}
      >
        <ContentWrapper>
          <Button
            styleType="loudLarge"
            onClick={onClick}
            alignIcon="left"
            data-cy-id={
              position === 'bottom' ? 'loadNextSection' : 'loadPreviousSection'
            }
          >
            <EyeSolid />
            {children}
          </Button>
          {canViewLimitDescription && (
            <p data-cy-id="plan-restriction">
              {'You have viewed'} <span>{limits.views}</span>
              {` / ${limits.limit} full reports over 30 days`}
            </p>
          )}
        </ContentWrapper>
      </Observer>
    </ButtonRow>
  );
}

export default ShowFullReportConfirm;
